import React, { useState } from 'react';
import { Box, Typography, TextField, Divider } from '@mui/material';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, rectSortingStrategy } from '@dnd-kit/sortable';
import ServeOrderCard from 'components/ServeOrderCard';
import CustomSearch from 'components/Fileds/CustomSearch';
import "./style.css";
import CustomTypography from 'components/Fileds/CustomTypography';
import theme from 'theme/ThemeContext';

export default function ServeStatusColumn({
    statusKey, label, color, items, ordersMap,
    onArrowClick, onReorder, validTransitions, textColor
}) {
    const { setNodeRef, isOver } = useDroppable({ id: statusKey });
    const [search, setSearch] = useState('');

    const filtered = items?.filter(id => {
        const o = ordersMap[id];
        return o?.order_no?.includes(search) ||
            o?.item_name.toLowerCase().includes(search.toLowerCase());
    });

    return (
        <Box
            ref={setNodeRef}
            className='d-flex serve-status-column-container'
        >
            {/* column header */}
            <Box className='status-column' sx={{ bgcolor: color, py: 1, px: 2 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: textColor, fontSize: '18px' }}>
                    {label} <span style={{ float: 'right' }}>{filtered.length}</span>
                </Typography>
            </Box>
            <Box className='search-box'>
                <CustomSearch
                    onSearchChange={setSearch}
                    searchQuery={search}
                    placeholder={"Search Order"}
                    isLoading={false}
                />
            </Box>
            <Box className='search-orders-container'>
                {/* cards */}
                {
                    filtered?.length > 0 ? (
                        <SortableContext items={filtered} strategy={rectSortingStrategy}>
                            <Box sx={{ padding: '10px', overflowY: 'auto', flexGrow: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
                                {filtered?.map(id => (
                                    <ServeOrderCard
                                        key={id}
                                        order={ordersMap[id]}
                                        from={statusKey}
                                        onArrowClick={onArrowClick}
                                        validTransitions={validTransitions}
                                    />
                                ))}
                            </Box>
                        </SortableContext>
                    ) : (
                        <Box className='d-flex align-items-center justify-content-center' sx={{ height: '100%' }}>
                            <CustomTypography
                                variant="body2"
                                label={"No Items"}
                                sx={{ fontSize: '16px', fontWeight: '500', color: theme.palette.drawermenuitem.main }}
                            />
                        </Box>
                    )
                }
            </Box>
        </Box>
    );
}
